import { Stack } from '@startuptools/ui/Stack';
import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/joy/Button';
import { Controller } from 'react-hook-form';
import { StepProps } from '../../types';
import { BoardLimit } from '../BoardLimit';
import { UpdateField } from '../UpdateField';

export const StepBoardLimits = ({ form, onSave, loading }: StepProps) => {
  return (
    <form
      onSubmit={form.handleSubmit(
        ({
          minimumNumberOfBoardMembers,
          maximumNumberOfBoardMembers,
          minimumNumberOfSubstitutes,
          maximumNumberOfSubstitutes,
          minimumNumberOfAuditors,
          maximumNumberOfAuditors,
          minimumNumberOfSubstituteAuditors,
          maximumNumberOfSubstituteAuditors,
          changeBoardLimits,
          changeNumberOfAuditors,
        }) =>
          onSave({
            minimumNumberOfBoardMembers,
            maximumNumberOfBoardMembers,
            minimumNumberOfSubstitutes,
            maximumNumberOfSubstitutes,
            minimumNumberOfAuditors,
            maximumNumberOfAuditors,
            minimumNumberOfSubstituteAuditors,
            maximumNumberOfSubstituteAuditors,
            changeBoardLimits,
            changeNumberOfAuditors,
          }),
      )}
    >
      <Stack gap={2}>
        <Controller
          control={form.control}
          name="changeBoardLimits"
          key="changeBoardLimits"
          render={({ field }) => (
            <UpdateField value={field.value} onChange={field.onChange} label={<Trans id="Board limits" />} />
          )}
        />
        <BoardLimit form={form} min="minimumNumberOfBoardMembers" max="maximumNumberOfBoardMembers">
          {values => <Trans id="The board shall have at least {min} and at most {max} members" values={values} />}
        </BoardLimit>
        <BoardLimit form={form} min="minimumNumberOfSubstitutes" max="maximumNumberOfSubstitutes">
          {values => <Trans id="The board shall have at least {min} and at most {max} substitutes" values={values} />}
        </BoardLimit>

        <Controller
          control={form.control}
          name="changeNumberOfAuditors"
          key="changeNumberOfAuditors"
          render={({ field }) => (
            <UpdateField value={field.value} onChange={field.onChange} label={<Trans id="Auditors" />} />
          )}
        />

        <BoardLimit form={form} min="minimumNumberOfAuditors" max="maximumNumberOfAuditors">
          {values => <Trans id="The company shall have at least {min} and at most {max} auditors" values={values} />}
        </BoardLimit>
        <BoardLimit form={form} min="minimumNumberOfSubstituteAuditors" max="maximumNumberOfSubstituteAuditors">
          {values => (
            <Trans id="The company shall have at least {min} and at most {max} substitute auditors" values={values} />
          )}
        </BoardLimit>

        <Stack direction="row" justifyContent="flex-start">
          <Button type="submit" loading={loading}>
            <Trans id="Next" />
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
